import { render, staticRenderFns } from "./CardBillingData.vue?vue&type=template&id=3322e87e&scoped=true&"
import script from "./CardBillingData.vue?vue&type=script&lang=js&"
export * from "./CardBillingData.vue?vue&type=script&lang=js&"
import style0 from "./CardBillingData.vue?vue&type=style&index=0&id=3322e87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322e87e",
  null
  
)

export default component.exports